const useCancellablePromises = () => {
    let pendingPromises: Array<any> = [] // explicitly typed to any since typescript is complaining that cancel is not on type Promise<>

    const appendPendingPromise = (promise: any) =>
        (pendingPromises = [...pendingPromises, promise])

    const removePendingPromise = (promise: any) =>
        (pendingPromises = pendingPromises.filter((p) => p !== promise))

    const clearPendingPromises = () => pendingPromises.map((p) => p.cancel())

    const api = {
        appendPendingPromise,
        removePendingPromise,
        clearPendingPromises,
    }

    return api
}

export default useCancellablePromises
